<!--  -->
<template>
  <div class="progress" v-if="list.length > 0">
    <CpSteps >
      <CpStep
        class="progress__step"
        v-for="(item,i) in list"
        :key="i"
        :isLast="i === list.length - 1"
        :color='main'
        @titleClick="handleTitleClick(item)"
        :ancillaryColor="ancillaryColor"
        :activeStatus="item.status"
        :list="list"
        :currentIndex="i + 1"
      >
        <div slot="next">{{ item.linkName }}</div>
        <div class="item_name"><pre>{{ item.itemName }}</pre></div>
      </CpStep>
    </CpSteps>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array
    },
    main:{
      type:String
    },
    ancillaryColor: String
  },
 
  methods: {
    handleTitleClick(item) {
     this.$emit('titleClick', item)
    },
  },
}

</script>
<style lang='less' scoped>
.progress {
  margin: 0 auto;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 658px;
  max-width: 658;
  min-height: 185px;
  .item_name{
    pre{
      font-family: 'PingFang SC', 'Microsoft Yahei', 'Helvetica Neue', 'Helvetica Arial', 'Avenir', 'Segoe UI', 'Hiragino Sans GB', STHeiti, 'Microsoft Sans Serif', 'WenQuanYi Micro Hei', sans-serif;
    }
  }
}
</style>